import { ModelContract, ModuleDescription } from "@features/shared/module-description";
import { createRouteUnit } from "@features/app/routes";

const contract = new ModelContract(
    {
        upsell: createRouteUnit({ path: "/upsell" }),
        profile: createRouteUnit({ path: "/profile" }),
        assistant: createRouteUnit({ path: "/assistant" }),
        iosApp: createRouteUnit({ path: "/app-onboarding" }),
        home: createRouteUnit({ path: "/home" }),
        challenges: createRouteUnit({ path: "/challenges" }),
        aiTools: createRouteUnit({ path: "/ai-tools" }),
        onboarding: createRouteUnit({ path: "/onboarding" }),
        experiment: createRouteUnit({ path: "/experiment" }),
        promptsLibrary: createRouteUnit({ path: "/prompts-library" }),
        lesson: createRouteUnit({ regex: /^\/course\/\d+\/topic\/\d+\/lesson\/\d+/ }),
        changeBrowser: createRouteUnit({ path: "/change-browser" }),
        library: createRouteUnit({ path: "/library" })
    },
    {},
    {},
    {}
);

export type IAppRouteUnitsContract = typeof contract;

export type RouteUnitName = keyof IAppRouteUnitsContract["stores"];

export class AppRouteUnitsModule extends ModuleDescription<IAppRouteUnitsContract> {
    getDefaultContract() {
        return contract;
    }
}
